// src/pages/users/UsersPage.js

import React, { useMemo } from 'react'; // Keep useMemo import
import GenericListPage from '../GenericListPage';
import UserForm from './UserForm';

const userColumns = [
  {
    header: 'ID',
    key: '_id',
    render: (user) => (
      <span className="font-mono text-xs text-gray-500" title={user._id}>
        {user._id.substring(0, 8)}...
      </span>
    ),
  },
  { header: 'Username', key: 'username' },
  { header: 'Email', key: 'email' },
  {
    header: 'Role',
    key: 'role',
    render: (user) => {
      const role = user.role || 'N/A';
      const roleColor = role === 'Owner' ? 'bg-indigo-100 text-indigo-800' : 'bg-gray-100 text-gray-800';
      return (
        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${roleColor}`}>
          {role.replace('_', ' ')}
        </span>
      );
    },
  },
];

const UsersPage = () => {
  // --- FIX: Move useMemo inside the functional component ---
  const userFilterConfig = useMemo(() => [
    {
      name: 'roleId',
      type: 'select',
      label: 'Role',
      endpoint: 'roles',
      keyField: '_id',
      valueField: 'name',
    },
    {
      name: 'activeSince',
      type: 'date',
      label: 'Active Since',
    }
  ], []); // Empty dependency array means it's created once on mount

  return (
    <GenericListPage
      title="Users"
      permission="manage_users"
      entityEndpoint="users"
      columns={userColumns}
      FormComponent={UserForm}
      filterConfig={userFilterConfig}
    />
  );
};

export default UsersPage;
